// START DYNAMIC TABBING JS
document.querySelectorAll('.accordion-title').forEach(title => {
  title.addEventListener('click', () => {
    const item = title.parentElement;
    const isOpen = item.classList.contains('active');

    // Close all items
    document.querySelectorAll('.accordion-item').forEach(i => i.classList.remove('active'));

    // Toggle clicked item
    if (!isOpen) {
      item.classList.add('active');
    }
  });
});
// END DYNAMIC TABBING JS
